import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { CAMPAIGN_STATUSES, CAMPAIGN_STATUSES_RUNNING_OR_RUNNED } from "campaign/model"
import { campaignActionCreator } from "campaign/store/actions"
import { messageSVC } from "message/service"
import { getCampaignsReports } from "reports/tools/campaign"

export const campaignStatusHaveReport = (status: CAMPAIGN_STATUSES): boolean =>
  CAMPAIGN_STATUSES_RUNNING_OR_RUNNED.includes(status)

export function loadListCampaignReports(): Promise<void> {
  return new Promise<void>(async resolve => {
    try {
      const campaignsHavingReports = getStore()
        .getState()
        .campaign.campaignList.filteredEntities.filter(c => campaignStatusHaveReport(c.status_id))
      if (campaignsHavingReports.length === 0) {
        return
      }
      getStore().dispatch(campaignActionCreator.setList(false, false, { isLoadingReports: true }))
      const reports = await getCampaignsReports(campaignsHavingReports.map(c => c.id))
      getStore().dispatch(campaignActionCreator.setListCampaignsReports(reports))
      resolve()
    } catch (error) {
      console.error(error)
      getStore().dispatch(campaignActionCreator.setList(false, false, { isLoadingReports: false }))
      messageSVC.error(translate("campaign.reports.error"))
      resolve()
    }
  })
}
